import type { SdkConfig } from '../core/types';
import type { Api } from '../core/api';
import { nowMs } from '../core/utils';

const HEARTBEAT_MS = 15_000;
const MIN_SESSION_S = 2;

export function installEngagement(config: SdkConfig, emblue: Api): void {
	if (!config.autoTrack.engagement) return;
	if (typeof window === 'undefined' || typeof document === 'undefined') return;

	const sessionStart = nowMs();
	let visible = document.visibilityState === 'visible';
	let activeStart = visible ? sessionStart : 0;
	let activeMs = 0;
	let heartbeat: ReturnType<typeof setInterval> | null = null;

	const startHb = () => {
		if (heartbeat) return;
		heartbeat = setInterval(() => {
			/* presence keeps the tab "active" in the eyes of any listener */
		}, HEARTBEAT_MS);
	};
	const stopHb = () => {
		if (heartbeat) {
			clearInterval(heartbeat);
			heartbeat = null;
		}
	};

	document.addEventListener('visibilitychange', () => {
		const now = nowMs();
		if (document.visibilityState === 'visible') {
			activeStart = now;
			visible = true;
			startHb();
		} else {
			if (visible && activeStart) activeMs += now - activeStart;
			visible = false;
			stopHb();
		}
	});

	window.addEventListener('pagehide', () => {
		const now = nowMs();
		const totalS = Math.floor((now - sessionStart) / 1000);
		if (visible && activeStart) activeMs += now - activeStart;
		const activeS = Math.floor(activeMs / 1000);
		if (totalS < MIN_SESSION_S) return;
		emblue.track('engagement_time', {
			seconds: activeS,
			total_seconds: totalS,
		});
		// Force a beacon flush so the event isn't lost on unload.
		emblue.flush();
	});

	if (visible) startHb();
}
